import { Label, Option, Select } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { StyledLabelContainer } from './OrganisationEditorModal';
import { useGetAllTenants } from '../../apollo/queries/getAllTenants.queries';
import { SHARED_TENANT } from '../../utils/constants';

interface SharedTenantDropdownProps {
  selectedTenantCode: string;
  width?: string;
  onChange: (tenantCode: string) => void;
}

const StyledContainer = styled.div<{ width: string }>`
  display: flex;
  width: ${({ width }) => width};
  flex-direction: column;
`;

const SharedTenantDropdown = ({
  selectedTenantCode,
  onChange,
  width = '100%',
}: SharedTenantDropdownProps) => {
  const allTenants = useGetAllTenants().tenants.concat([SHARED_TENANT]);

  return (
    <StyledContainer width={width}>
      <StyledLabelContainer>
        <Label title="Tenant" />
      </StyledLabelContainer>
      <Select
        searchable
        data-testid="select-tenant"
        selectedOption={selectedTenantCode || SHARED_TENANT}
        onSelectChange={(_id, name) => {
          onChange(name);
        }}
        placeholder="Select Tenant"
      >
        {allTenants.map((tenant) => (
          <Option key={tenant}>{tenant}</Option>
        ))}
      </Select>
    </StyledContainer>
  );
};

export default SharedTenantDropdown;
